export default {
    GET_DELIVERY_ADDRESS: "GET_DELIVERY_ADDRESS",
    GET_DELIVERY_ADDRESS_SUCCESS: "GET_DELIVERY_ADDRESS_SUCCESS",
}